import styled from 'styled-components';

export const Header = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  padding: 0 1.5rem 1rem 1.5rem;
  & > .hefesto-title h1 {
    color: ${({ theme }) => theme.colors.grayDark3};
    margin-bottom: 0;
  }
  & > .subtitle {
    font-size: 1rem;
    font-family: ${({ theme }) => theme.fonts.workSans};
    color: ${({ theme }) => theme.colors.grayDark2};
  }

  .hefesto-step-by-step__content {
    margin: 0;
  }
`;

export const HeaderButtonsContainer = styled.div`
  display: flex;
  gap: 1rem;

  button:nth-child(2) {
    width: 48px;
    display: flex;
    justify-content: center;
  }
`;

export const HeaderSection = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;

  .subtitle {
    color: ${({ theme }) => theme.colors.grayDark4};
    font-family: ${({ theme }) => theme.fonts.workSans};
  }
`;

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.gray8};
`;

export const ContentToggle = styled.button<{ fullWidth?: boolean }>`
  background: none;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.colors.blue6};
  gap: 0.5rem;

  cursor: pointer;

  margin-left: 1.5rem;
  height: 48px;
  ${({ fullWidth }) => !fullWidth && `width: 48px;`}
`;

export const ResumeHeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const OrderDetailContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding: 1.5rem;
`;
